import "./lame-shim";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "react-query";

import ErrorBoundary from "./errors/ErrorBoundary";
import queryClient from "./services/queryClient";

// Lazy import so MUI/emotion initialize in their own chunk before App renders,
// preventing the TDZ caused by Rollup's circular-dep resolution in MUI internals.
const App = React.lazy(() => import("./App"));

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<ErrorBoundary>
				<QueryClientProvider client={queryClient}>
					<React.Suspense fallback={null}>
						<App />
					</React.Suspense>
				</QueryClientProvider>
			</ErrorBoundary>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);


